import {TModuleListHeaderCell} from '../_types'
import {FC, memo, useMemo} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

export const HeaderCell: FC<TModuleListHeaderCell> = memo(props => {
  const { article, title, type, filter, setFilter, isListEditable, isNewUI } = props
  const isSortableData = useMemo(() => {
    if (!isListEditable) {
      return false
    } else {
      switch (type) {
        case "string":
        case "year":
        case "integer":
        case "float":
        case "email":
        case "date":
        case "time":
        case "datetime":
        case "phone":
        case "price":
        case "checkbox":
          return true
        default:
          return false
      }
    }
  }, [type, isListEditable])

  const isDataSortedByCurrentArticle = isSortableData && filter.sort_by === article
  const isReverseSort = isDataSortedByCurrentArticle && filter.sort_order === "desc"
  const currentClassList = `moduleList_headerCell ${type}`
  const currentTitle = type === "image" ? title : title

  const handleSort = () => setFilter((prev: any) => {
    const filterValuesClone = { ...prev }
    filterValuesClone.page = 1
    filterValuesClone.sort_by = article
    filterValuesClone.sort_order = prev.sort_by === article && prev.sort_order === "asc" ? "desc" : "asc"
    return filterValuesClone
  })

  return (
    <th className={currentClassList}>
      {isSortableData ? (
        <>
          {isNewUI || <span>{currentTitle}</span>}
          <button
            type='button'
            className={`moduleList_sortButton${isDataSortedByCurrentArticle ? ' sorted' : ''}${
              isReverseSort ? ' reverse' : ''
            }`}
            onClick={handleSort}

          >
            {!isNewUI || <span>{currentTitle}</span>}
            <KTSVG path={`/media/crm/icons${isNewUI ? "/newUI": ""}/sort.svg`}/>
          </button>
        </>
      ) : <span>{currentTitle}</span>}
    </th>
  )
})